import { createAction, props } from "@ngrx/store";

import { Code, Severity } from "./notification.state";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Business Actions (those type of actions are initially dispatched)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const createNotifications = createAction(
  "[Notification] [Business] Create Notifications",
  props<CreateNotificationsParameters>(),
);

export const createNotificationIfNotFound = createAction(
  "[Notification] [Business] Create Notification If Not Found",
  props<CreateIfNotFoundNotificationParameters>(),
);

export const tryDeleteNotification = createAction(
  "[Notification] [Business] Try Delete Notification",
  props<TryDeleteNotificationByIdParameters>(),
);

export const tryDeleteNotifications = createAction(
  "[Notification] [Business] Try Delete Notification",
  props<DeleteNotificationByCodeParameters>(),
);

export const tryDeleteDeleteAfterNextNavigationNotificationMessages =
  createAction(
    "[Notification] [Business] Try Delete Delete After Next Navigation Notification Messages",
  );

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Chain Reaction Action (those type of actions are never directly dispatched but are triggered as a result of a business action)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Models
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface NotificationMessagePayload {
  severity: Severity;
  code: Code;
  text?: string;
  markdown?: string;
  deleteAfterNextNavigation?: boolean;
  deleteAfterNumberOfMilliseconds?: number;
}

export interface CreateNotificationsParameters {
  notificationMessagePayloads: NotificationMessagePayload[];
}

export interface CreateIfNotFoundNotificationParameters {
  notificationMessagePayload: NotificationMessagePayload;
}

export interface TryDeleteNotificationByIdParameters {
  notificationId: number;
}

export interface DeleteNotificationByCodeParameters {
  code: Code;
}
